<template>
    <div class="garanties-list">
        <div class="clients__title">
            Importer des garanties
        </div>

        <template v-if="isLoading">
            <Preloader />
        </template>
        <template v-else>
          <div class="garanties-filter">
            <div class="garanties-filter--wrap">
              <div class="garanties-filter__fields">
                <div class="garanties-filter__buttons">
                  <button class="garanties-filter__buttons--button template" @click="uploadGarantiesImportTemplate">Télécharger le modèle</button>
                </div>

                <ImportGuaranteesLoadFileInput
                  v-model="document.file"
                  :options="document.options"
                  :allowedFileExtensions="document.allowedFileExtensions"
                  @uploaded="importDone"
                />

                  <GarantieResponseModal v-show="importResponseModal" @close="closeImportModal" :result="importResult" />

              </div>
            </div>
          </div>
        </template>
    </div>
</template>

<script>
    import Preloader from '@/components/Preloader';
    import ImportGuaranteesLoadFileInput from "./ImportGuaranteesLoadFileInput";
    import GarantieResponseModal from "../GarantieResponseModal";

    export default {
        name: "GarantiesImport",
        components: {GarantieResponseModal, ImportGuaranteesLoadFileInput, Preloader},
        mixins: [],
        data() {
            return {
              importResponseModal: false,
              importResult: {},
              document: {
                type: 'IMPORT_GUARANTEES',
                title: '',
                file: null,
                options: {name: 'Choisir un document', placeholder: true, currentFile: false, hash: null},
                allowedFileExtensions: `application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`
              },
              isLoading: false,
            }
        },
        computed: {},
        watch: {},
        methods: {
          uploadGarantiesImportTemplate() {
            window.location = this.getApiAuthUrl(`guarantees/export/template`);
          },
            importDone(data) {
                this.importResult = data;
                this.importResponseModal = true;
            },
            closeImportModal() {
              this.importResponseModal = false;
            }
        },
        mounted() {}

    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/Import/GarantiesImport.vue